import script from "./AdditionalPhotoUploadModalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalPhotoUploadModalComponent.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalPhotoUploadModalComponent.vue?vue&type=style&index=0&id=29d09226&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d09226"]])

export default __exports__